import { PropType } from 'vue-demi';
import { Conferences } from '@or-sdk/hitl';

import { IAgent, Contact } from '@/types';
import { AvatarOptions } from '@onereach/hitl-base-avatars';
import { ListItemAction, CALL_MEMBER_TYPE, CALL_MEMBER_STATUS } from './types';

export const AVATAR_PROP = {
  type: Object as PropType<AvatarOptions>,
  default: undefined,
};

/** Agent is always a required prop in Dialer */
export const AGENT_PROP = {
  type: Object as PropType<IAgent>,
  required: true,
  default: undefined,
};

/** Contact usually is also present, but can be disconnected from the call */
export const CONTACT_PROP = {
  type: Object as PropType<Contact>,
  required: false,
  default: undefined,
};

export const PERSON_PROP = {
  type: Object as PropType<IAgent | Contact>,
  default: undefined,
};

export const MEMBERS_PROP = {
  type: Array as PropType<Conferences.Conference[]>,
  default: () => [],
};

export const RULE_GROUPS_PROP = {
  type: Array,
  default: () => [],
};

export const SIZE_PROP = {
  type: String as PropType<'desktop' | 'mobile'>,
  default: 'desktop' as const,
};

export const TABS_DISPLAY_PROP = {
  type: String as PropType<'inline' | 'compact'>,
  default: 'inline' as const,
};

export const LIST_ITEM_ACTIONS_DISPLAY_PROP = {
  type: String as PropType<'inline' | 'popup'>,
  default: 'inline' as const,
};

export const LIST_ITEM_ACTIONS_PROP = {
  type: Array as PropType<ListItemAction[]>,
  default: () => [],
};

export const AGENT_ACTIONS_TYPE_PROP = {
  type: String as PropType<'invite' | 'transfer'>,
  default: 'invite',
};

export const AGENT_ACTIONS = {
  ADD_AGENT: 'invite-agent',
  ADD_3RD_PARTY: 'invite-3rd-party',
};

export const CALL_MEMBER_STATUS_LABEL: Record<string, string> = {
  [CALL_MEMBER_STATUS.JOINED]: 'hitl.modules.dialer.member-status.joined',
  [CALL_MEMBER_STATUS.CONNECTED]: 'hitl.modules.dialer.member-status.connected',
  [CALL_MEMBER_STATUS.RINGING]: 'hitl.modules.dialer.member-status.ringing',
  [CALL_MEMBER_STATUS.ON_HOLD]: 'hitl.modules.dialer.member-status.on-hold',
  [CALL_MEMBER_STATUS.MUTED]: 'hitl.modules.dialer.member-status.muted',
  [CALL_MEMBER_STATUS.ERROR]: 'hitl.modules.dialer.member-status.error',
  [CALL_MEMBER_STATUS.BUSY]: 'hitl.modules.dialer.member-status.busy',
  [CALL_MEMBER_STATUS.NOT_CONNECTED]: 'hitl.modules.dialer.member-status.not-connected',
  [CALL_MEMBER_STATUS.DISCONNECTED]: 'hitl.modules.dialer.member-status.disconnected',
  [CALL_MEMBER_STATUS.HANG_UP]: '',
};

export const CALL_MEMBER_TYPE_LABEL: Record<string, string> = {
  [CALL_MEMBER_TYPE.AGENT]: 'hitl.modules.dialer.member-type.agent',
  [CALL_MEMBER_TYPE.CONTACT]: 'hitl.modules.dialer.member-type.contact',
  [CALL_MEMBER_TYPE.THIRD_PARTY]: 'hitl.modules.dialer.member-type.3rd-party',
};

export const CALL_MEMBER_STATUS_COLOR: Record<string, string> = {
  [CALL_MEMBER_STATUS.CONNECTED]: 'success',
  [CALL_MEMBER_STATUS.JOINED]: 'success',
  [CALL_MEMBER_STATUS.RINGING]: 'warning',
  [CALL_MEMBER_STATUS.ON_HOLD]: 'warning',
  [CALL_MEMBER_STATUS.MUTED]: 'warning',
  [CALL_MEMBER_STATUS.ERROR]: 'error',
  [CALL_MEMBER_STATUS.BUSY]: 'error',
  [CALL_MEMBER_STATUS.NOT_CONNECTED]: 'error',
  [CALL_MEMBER_STATUS.DISCONNECTED]: 'neutral',
  [CALL_MEMBER_STATUS.HANG_UP]: 'neutral',
};

/** TODO: Move to translations? */
export const STEP_EVENTS = {
  AGENT_ANSWERED_CALL: 'Agent answered the call',
  AGENT_MUTED_CALL: 'Agent muted the call',
  AGENT_UNMUTED_CALL: 'Agent unmuted the call',
  AGENT_HUNG_UP_CALL: 'Agent hung up the call',
  AGENT_REJECTED_CALL: 'Agent rejected the call',
  AGENT_PUT_CALL_ON_HOLD: 'Agent put call on hold',
  AGENT_PUT_CALL_OFF_HOLD: 'Agent put call off hold',
};
